export default __webpack_public_path__ + "static/media/documentation.083800a6.yaml";